import { UntypedFormGroup } from '@angular/forms';
import { _safe } from '@ordersnproducts/modules/shared/utils/safe-get.method';
import { asyncScheduler, defer, scheduled } from 'rxjs';
import { Observable } from 'rxjs';
import { concatAll, map, take } from 'rxjs/operators';

/**
 * Function to check if unloadType is a PUMP type
 *
 * @param value unloadType value
 * @param source list of unloadType values to compare
 * @returns true if value is PUMP or PUMPING otherwise false
 */
export function isPumpUnloadType(value: string, source = []) {
  return source.some((item) => !!value && value === item);
}

/**
 * Listen to changes of a formGroup field but take the initial value from the store
 *
 * @param source$ observable of initial values from store(getOrdersForms)
 * @param form form group that contains the field
 * @param fieldName id of formControl
 * @returns Observable of the field value
 */
export function startWithOrderFormState$<T>(
  source$: Observable<any>,
  form: UntypedFormGroup,
  fieldName: string,
): Observable<T> {
  const startWithSource$ = source$.pipe(
    take(1),
    map((entities) => {
      const id = form.get('id').value;
      const orderForm = entities[id];
      const shown = _safe(() => orderForm.shown, true);
      const defaultValue = form.get(fieldName).value;
      const initialValueState = _safe(() => orderForm.values[fieldName]);
      return shown ? defaultValue : initialValueState;
    }),
  );
  const control = form.controls[fieldName];
  return scheduled([defer(() => startWithSource$), control.valueChanges], asyncScheduler).pipe(concatAll());
}
